import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: '20px',
    paddingBottom: '20px',
    paddingLeft: '20px',
    paddingRight: '20px',
    maxWidth: '85em',
    margin: '0 auto',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  header: {
    marginBottom: '20px',
    textAlign: 'center',
    fontWeight: '700 !important',
  },
  subtitle_info:{
    marginBottom: '20px',
    textAlign:'left',
    fontWeight: '700 !important',
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  input: {
    padding: '11px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    width: '100%',
  },
  checkbox: {
    marginLeft: '10px',
  },
  buttonContainer: {
    marginTop: '20px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-around',
  },
  resultContainer: {
    marginTop: '40px',
  },
  list: {
    marginTop: '20px',
    marginLeft: '1em',
  },
  listItem: {
    marginBottom: '5px',
  },
  circularContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
  },
  customFilterInput: {
    marginLeft: '10px',
    width: '150px',
  },
  filterRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
  },
  filterColumn: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
  },
  filterColumnRight: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default useStyles;